import React from 'react';

const EnvDebug = () => {
  return (
    <div style={{ display: 'none' }}>
      {/* This component is hidden but will log environment variables to the console */}
      {console.log('Environment Variables Debug:')}
      {console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL)}
      {console.log('NODE_ENV:', process.env.NODE_ENV)}
    </div>
  );
};

export default EnvDebug;
